// extracted by mini-css-extract-plugin
export var acitonButtons = "_g9-0";
export var additionalIcon = "_g9-f";
export var block = "_g9-1";
export var blockContent = "_g9-7";
export var blockDescription = "_g9-8";
export var blockIcon = "_g9-9";
export var blockTitle = "_g9-6";
export var border = "_g9-a";
export var center = "_g9-l";
export var edge = "_g9-b";
export var edgeLabel = "_g9-c";
export var edgePath = "_g9-d";
export var error = "_g9-e";
export var flowchart = "_g9-g";
export var flowchartContent = "_g9-h";
export var highlighted = "_g9-3";
export var hover = "_g9-4";
export var icon = "_g9-i";
export var left = "_g9-m";
export var navButton = "_g9-j";
export var navButtons = "_g9-k";
export var right = "_g9-n";
export var selected = "_g9-2";
export var small = "_g9-5";